import React from 'react';
import PropTypes from 'prop-types';
import Day from 'dayjs';
import { Link } from 'react-router-dom';

const Item = ({item, setOpen, isOrder, link}) => {
    return (
        <li className="notification-list-item">
            <div className="notification-item-icon-wrap">
                <i className={(item.urlTarget === '_order') ? ' jumbo-icon-new-front-box ' : ' jumbo-icon-new-bell '}></i>
            </div>

            <Link className='notification-list-link' to={link} onClick={() => { setOpen(false) }}><div className="notification-list-info-wrap">
                <span className="notification-list-info-title">{item.title}</span>
                <span className="notification-list-info-message">{isOrder ? (item.url + ' - ') : ''}{item.message}</span>
                <span className="notification-list-info-date">{Day(item.date).format('DD/MM/YYYY')}</span>
            </div></Link>
        </li>
    )
}


Item.propTypes = {
    item: PropTypes.object,
    setOpen: PropTypes.func,
    isOrder: PropTypes.bool,
    link: PropTypes.string
}

export default Item;
